module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Bold-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Bold-webfont.ttf
// module id = 371
// module chunks = 0